import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import PageHeading from "./PageHead";
import Footer from "./Footer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import InputWithLabel from "../Components/InputWithLabel";
import CustomButton from "../Components/CustomButton";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import "./Style.css";
import { useNavigate } from "react-router-dom";
import {
  errorNotify,
  succesNotify,
} from "../CommonCode/Commonfunc";
import { axiosAPI } from "../Axios/Axios";

import { useSelector } from "react-redux";
import {profanityfn}  from "../Profanity/Profanity";
import { businessContact } from "./businessInfo";
import JacobLogo from "../../Images/JCH-logo-cropped.png";

function Contact() {
  const redirect = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    language:localStorage.getItem("language")
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const ProfanityList = useSelector((state)=> state.Profanity.wordlist)

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;
    if (name === "phone") {
      newValue = value.replace(/[^0-9]/g, "");
    }
    setFormData({
      ...formData,
      [name]: profanityfn(ProfanityList,newValue),
    });
    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const submitContactForm = async (e) => {
    e.preventDefault();
    let errors = {};
    if (formData.name === "") {
      errors.name = Labels?.nameRequired;
    }
    if (formData.phone === "") {
      errors.phone =  Labels?.phoneNumberRequired;
    } else if (!/^\d+$/.test(formData.phone)) {
      errors.phone =
        Labels?.phoneNumberValidation;
    }
    if (formData.email === "") {
      errors.email =  Labels?.emailValidation;
    }
    if (formData.message === "") {
      errors.message = Labels?.Messageisrequired;
    }
    if (Object.keys(errors).length > 0) {
      // Set the form errors and display error messages
      setFormErrors(errors);
      return;
    }
    axiosAPI
      .post("/saveContactUs", formData)
      .then((response) => {
        const { success, message } = response.data;

        if (success === true) {
          errorNotify(message);
          setFormData({
            name: "",
            phone: "",
            email: "",
            message: "",
          });
        } else {
          succesNotify(message);
          setTimeout(() => {
            redirect("/landingpage");
          }, 3000);
        }
      })
      .catch((error) => {
        errorNotify(error);
      });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const Labels = useSelector((state) => state.allLabels.labels);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    businessContact.address
  )}`;
  return (
    <Container
      maxWidth="100%"
      sx={{ margin: "0 auto", padding: "0 !important" }}
    >
      <PageHeading pageHeading={Labels?.Contactus} />
      <Box
        sx={{
          background:
            "linear-gradient(145deg, #fff8ec 0%, #f6fbf9 42%, #e9f7fb 100%)",
          pb: { xs: 8, md: 10 },
          pt: { xs: 5, md: 7 },
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
            <Grid item xs={12} md={7}>
              <Box
                component="form"
                autoComplete="off"
                noValidate
                onSubmit={submitContactForm}
                sx={{
                  background: "#fff",
                  border: "1px solid rgba(19, 110, 155, 0.14)",
                  borderRadius: "14px",
                  boxShadow: "0 22px 55px rgba(40, 32, 20, 0.12)",
                  height: "100%",
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Stack spacing={0.75} sx={{ mb: 3 }}>
                  <Typography
                    component="p"
                    sx={{
                      color: "#8a5a1f",
                      fontSize: 13,
                      fontWeight: 700,
                      letterSpacing: 1,
                      textTransform: "uppercase",
                    }}
                  >
                    Jacob's Coffee House
                  </Typography>
                  <Typography
                    component="h2"
                    sx={{
                      color: "#004f76",
                      fontSize: { xs: 28, md: 34 },
                      fontWeight: 700,
                      lineHeight: 1.15,
                    }}
                  >
                    Send Us a Message
                  </Typography>
                  <Typography sx={{ color: "#53605d", fontSize: 15 }}>
                    Questions about jobs, hiring, or visiting us in Costa Rica?
                    Share a few details and our team will get back to you.
                  </Typography>
                </Stack>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <InputWithLabel
                      style={{ width: "100%" }}
                      InputLabel={Labels?.name || "Name"}
                      label={Labels?.name || "Name"}
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      errorMsg={formErrors.name}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputWithLabel
                      style={{ width: "100%" }}
                      InputLabel={Labels?.Phone || "Phone"}
                      label={Labels?.Phone || "Phone"}
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      errorMsg={formErrors.phone}
                      inputProps={{
                        autoComplete: "off",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputWithLabel
                      style={{ width: "100%" }}
                      InputLabel={Labels?.emailAddress || "Email Address"}
                      label={Labels?.emailAddress || "Email Address"}
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      errorMsg={formErrors.email}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputWithLabel
                      style={{ width: "100%" }}
                      InputLabel={Labels?.Messages || "Message"}
                      label={Labels?.Messages || "Message"}
                      type="text"
                      name="message"
                      multiline
                      rows={5}
                      value={formData.message}
                      onChange={handleInputChange}
                      errorMsg={formErrors.message}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </Grid>
                </Grid>

                <CustomButton
                  label={Labels?.Submit || "Submit"}
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0 12px 24px rgba(0, 95, 142, 0.22)",
                    marginTop: "18px",
                    minHeight: "44px",
                    width: "100%",
                  }}
                  onClick={submitContactForm}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  background: "linear-gradient(160deg, #005f8e 0%, #0f3f4a 100%)",
                  borderRadius: "14px",
                  boxShadow: "0 22px 55px rgba(0, 45, 65, 0.18)",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                  overflow: "hidden",
                  p: { xs: 3, sm: 4 },
                  "& a": {
                    color: "#fff",
                    textDecoration: "none",
                  },
                }}
              >
                <Box>
                  <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
                    <Box
                      component="img"
                      src={JacobLogo}
                      alt="Jacob's Coffee House"
                      sx={{
                        background: "#fff",
                        borderRadius: "10px",
                        height: 74,
                        objectFit: "contain",
                        p: 0.75,
                        width: 96,
                      }}
                    />
                    <Box>
                      <Typography sx={{ fontSize: 14, opacity: 0.78 }}>
                        Visit or Contact
                      </Typography>
                      <Typography
                        component="h3"
                        sx={{ fontSize: 24, fontWeight: 700, lineHeight: 1.2 }}
                      >
                        Jacob's Coffee House
                      </Typography>
                    </Box>
                  </Stack>

                  <Typography sx={{ color: "rgba(255,255,255,0.82)", mb: 3 }}>
                    We are located in Costa Rica's coffee-growing region and are
                    happy to connect with guests, job seekers, and partners.
                  </Typography>

                  <Stack
                    divider={<Divider sx={{ borderColor: "rgba(255,255,255,0.18)" }} />}
                    spacing={2.25}
                  >
                    <Stack direction="row" spacing={2} alignItems="flex-start">
                      <LocationOnIcon sx={{ color: "#f6d58c", mt: 0.3 }} />
                      <Box>
                        <Typography sx={{ fontWeight: 700 }}>Address</Typography>
                        <Typography sx={{ color: "rgba(255,255,255,0.82)" }}>
                          {businessContact.address}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={2} alignItems="center">
                      <CallIcon sx={{ color: "#f6d58c" }} />
                      <Box>
                        <Typography sx={{ fontWeight: 700 }}>Phone</Typography>
                        <Typography
                          component="a"
                          href={businessContact.phoneHref}
                          sx={{
                            color: "#fff !important",
                            textDecoration: "none",
                          }}
                        >
                          {businessContact.phoneDisplay}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={2} alignItems="center">
                      <MarkunreadIcon sx={{ color: "#f6d58c" }} />
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontWeight: 700 }}>Email</Typography>
                        <Typography
                          component="a"
                          href={businessContact.emailHref}
                          sx={{
                            color: "#fff !important",
                            overflowWrap: "anywhere",
                            textDecoration: "none",
                          }}
                        >
                          {businessContact.email}
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </Box>

                <Stack
                  direction={{ xs: "column", sm: "row", md: "column", lg: "row" }}
                  spacing={1.5}
                  sx={{
                    alignItems: { xs: "stretch", sm: "center", md: "stretch", lg: "center" },
                    mt: 4,
                  }}
                >
                  <Button
                    href={mapUrl}
                    target="_blank"
                    rel="noreferrer"
                    startIcon={<LocationOnIcon />}
                    variant="contained"
                    sx={{
                      background: "#fff",
                      borderRadius: "8px",
                      color: "#005f8e !important",
                      fontWeight: 700,
                      minHeight: 38,
                      px: 2,
                      textTransform: "none",
                      "& .MuiButton-startIcon": {
                        color: "#005f8e !important",
                      },
                      "&:hover": {
                        background: "#f6fbf9",
                        color: "#005f8e !important",
                      },
                    }}
                  >
                    Open Map
                  </Button>
                  <Button
                    href={businessContact.emailHref}
                    startIcon={<LocalCafeIcon />}
                    variant="outlined"
                    sx={{
                      borderColor: "rgba(255,255,255,0.6)",
                      borderRadius: "8px",
                      color: "#fff !important",
                      fontWeight: 700,
                      minHeight: 38,
                      px: 2,
                      textTransform: "none",
                      "& .MuiButton-startIcon": {
                        color: "#fff !important",
                      },
                      "&:hover": {
                        borderColor: "#fff",
                        background: "rgba(255,255,255,0.1)",
                        color: "#fff !important",
                      },
                    }}
                  >
                    Email Us
                  </Button>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </Container>
  );
}
export default Contact;
